import { render, staticRenderFns } from "./DocumentCategoryCardComponent.vue?vue&type=template&id=035b5094&scoped=true&"
import script from "./DocumentCategoryCardComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentCategoryCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCategoryCardComponent.vue?vue&type=style&index=0&id=035b5094&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035b5094",
  null
  
)

export default component.exports